import { TTranslate } from "../../../service/locale/TranslationService";

export interface TDataGridConfigurationBuilderOptions {
  translate: TTranslate;
  resourcePrefix: string;
}

export interface TDataGridColumnConfiguration {
  title: string;
  dataIndex: string;
  key: string;
}

export interface TColumnConfiguration {
  name: string;
  dataKey?: string | string[];
  label?: string;
  width?: number;
  sorter?: any;
  sortable?: boolean;
  align?: string;
  render?: (record: any) => JSX.Element;
  editable?: boolean;
}

export type TColumnDescriptor = string | TColumnConfiguration;

const DataGridConfigurationBuilder = (
  options: TDataGridConfigurationBuilderOptions
) => {
  const { translate, resourcePrefix } = options;
  const buildColumn = (column: TColumnDescriptor) => {
    if (typeof column === "string") {
      return {
        title: translate(
          `${resourcePrefix ? resourcePrefix + "." : ""}${column}`
        ),
        dataIndex: column,
        key: column
      };
    }
    const {
      name,
      dataKey,
      render,
      label,
      sortable,
      sorter,
      editable,
      ...other
    } = column;
    let columnConfiguration: any = {
      title:
        label ||
        translate(`${resourcePrefix ? resourcePrefix + "." : ""}${name}`),
      dataIndex: dataKey || name,
      key: name,
      editable: editable ?? false
    };
    if (render) {
      columnConfiguration.dataIndex = undefined;
      columnConfiguration.render = render;
    }
    if (sortable === false) {
      columnConfiguration.sorter = undefined;
    }
    if (sorter) {
      columnConfiguration.sorter = sorter;
    }
    if (other) {
      columnConfiguration = {
        ...columnConfiguration,
        ...other
      };
    }

    return columnConfiguration;
  };
  return {
    buildColumn,
    buildColumns(...columns: TColumnDescriptor[]) {
      return (columns || []).map((item) => {
        return buildColumn(item);
      });
    }
  };
};

export default DataGridConfigurationBuilder;
